import { createSingleAction } from '../../../utils';
import { ISheetCaliforniaSubmissionPeriod } from '../models/SheetApprovals';

export const ADDED_CALIFORNIA_SUBMISSION = 'ADDED_CALIFORNIA_SUBMISSION';
export const addedCaliforniaSubmissionAction = createSingleAction<ISheetCaliforniaSubmissionPeriod,
    typeof ADDED_CALIFORNIA_SUBMISSION>(ADDED_CALIFORNIA_SUBMISSION);

export type CaliforniaSheetActions = ReturnType<typeof addedCaliforniaSubmissionAction>;
